import { Box, BoxProps, ButtonBase, Stack, StackProps, Typography } from "@mui/material"
import React from "react"

import { MyCard, MyCardTitle } from "./MyCard"

export function UnderTheHood() {
  return (
    <MyCard variant="transparent" sx={{ paddingX: 0 }}>
      <Stack gap={3} alignItems="stretch" width="100%" maxWidth={800}>
        <MyCardTitle id="under-the-hood">What&apos;s under the hood?</MyCardTitle>

        <Layer
          title="3. UX layer"
          description="Access your financial data when you need it, where you need it. Private and secure at all times."
          sx={{
            "& .edge": {
              background: `linear-gradient(
                              to left,
                              hsl(61 80% 20%) 0%,
                              hsl(61 80% 37%) 8%,
                              hsl(61 80% 37%) 92%,
                              hsl(61 80% 20%) 100%
                            )`,
            },
            "& .front": {
              background: "hsl(61 80% 58%)",
              color: "rgb(0,0,0)",
            },
          }}
        >
          <ItemBlock>Mobile apps</ItemBlock>
          <ItemBlock>Push notifications</ItemBlock>
          <ItemBlock>Reports</ItemBlock>
          <ItemBlock>AI Assistant</ItemBlock>
          <ItemBlock>Extensions</ItemBlock>
        </Layer>

        <Layer
          title="2. Compute layer"
          description="Crunching your data for insights and intelligence — uncovering the past, planning the future."
          sx={{
            "& .edge": {
              background: `linear-gradient(
                              to left,
                              hsl(273 90% 36%) 0%,
                              hsl(273 90% 57%) 8%,
                              hsl(273 90% 57%) 92%,
                              hsl(273 90% 36%) 100%
                            )`,
            },
            "& .front": {
              background: "hsl(273 90% 70%)",
            },
          }}
        >
          <ItemBlock>Net worth</ItemBlock>
          <ItemBlock>Profit & loss</ItemBlock>
          <ItemBlock>Risk metrics</ItemBlock>
          <ItemBlock>Deep research Agents</ItemBlock>
          <ItemBlock>Extensions</ItemBlock>
        </Layer>

        <Layer
          title="1. Data layer"
          description="Enabling sovereign individuals and organizations to own and manage their transaction and asset data."
          //  via APIs, files, and manual input."
          sx={{
            "& .edge": {
              background: `linear-gradient(
                              to left,
                              hsl(330deg 100% 16%) 0%,
                              hsl(330deg 100% 32%) 8%,
                              hsl(330deg 100% 32%) 92%,
                              hsl(330deg 100% 16%) 100%
                            )`,
            },
            "& .front": {
              background: "hsl(330deg 100% 47%)",
            },
          }}
        >
          <ItemBlock>File Imports</ItemBlock>
          <ItemBlock>Connections</ItemBlock>
          <ItemBlock>Manual Input</ItemBlock>
          <ItemBlock>Assets</ItemBlock>
          <ItemBlock>Prices</ItemBlock>
          <ItemBlock>Extensions</ItemBlock>
        </Layer>
      </Stack>
    </MyCard>
  )
}

export function ItemBlock({ children }: BoxProps) {
  return (
    <ButtonBase className="pushable" sx={{ marginTop: 1 }}>
      <span className="shadow"></span>
      <span className="edge"></span>
      <Box
        className="front"
        sx={{
          color: "primary.contrastText",
          fontSize: 14,
          fontWeight: 600,
          whiteSpace: "nowrap",
        }}
      >
        {children}
      </Box>
    </ButtonBase>
  )
}

export function Layer({
  title,
  description,
  children,
  sx,
  ...rest
}: StackProps & { description?: string }) {
  return (
    <Stack
      sx={{
        border: "2px dashed rgba(var(--mui-palette-primary-mainChannel) / 0.15)",
        borderRadius: 2,
        padding: 1.5,
        ...sx,
      }}
      {...rest}
      alignItems="flex-start"
      gap={2}
    >
      <Stack alignItems="flex-start" gap={0.5}>
        <MyCardTitle fontSize="1.5rem">{title}</MyCardTitle>
        <Typography variant="body2">{description}</Typography>
      </Stack>
      <Stack direction="row" gap={1} flexWrap="wrap">
        {children}
      </Stack>
    </Stack>
  )
}
